<section [class]="'s__cta-block' + (variant() === 'dark' ? ' s__bg-dark' : '')">
  <div class="s__cta-block__inner s__container">
    @if (heading()) {
      <h2 class="s__cta-block__heading">{{ heading() }}</h2>
    }

    @if (subtitle()) {
      <p class="s__cta-block__subtitle">{{ subtitle() }}</p>
    }

    @if (actions().length > 0) {
      <div class="s__cta-block__actions">
        @for (action of actions(); track action.label) {
          <a [attr.href]="action.href" [class]="'s__btn s__btn--' + action.variant">{{ action.label }}</a>
        }
      </div>
    }

    @if (escapeText() && escapeHref()) {
      <div class="s__cta-block__escape">
        <ds-link [href]="escapeHref()" variant="arrow">{{ escapeText() }}</ds-link>
      </div>
    }
  </div>
</section>
